import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import strings from 'owa-strings/owa-mail-strings';

export function getOpenInNewTabContextMenuItem(
    url: string,
    onClickCallback?: () => void
): IContextualMenuItem {
    return {
        name: strings.OpenInNewTabText,
        key: 'OpenInNewTab',
        onClick: () => {
            window.open(url, '_blank');
            if (onClickCallback) {
                onClickCallback();
            }
        },
    };
}
